const kqDialog = {
  state: {
    kqState: false,
    kqId: '',
    kqName: ''
  },
  mutations: {
    SET_KQSTATE: (state, kqState) => {
      state.kqState = kqState
    },
    SET_KQID: (state, kqId) => {
      state.kqId = kqId
    },
    SET_KQNAME: (state, kqName) => {
      state.kqName = kqName
    }
  
  },
  actions: {
  }
}

export default kqDialog
